/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/AccountCircle';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const AccountCircleIcon = withMuiAdapter(Base, 'AccountCircle');
